import React from 'react';
import BaseSkeleton from '../../common/skeleton';

export default function Skeleton({ count }) {
  return (
    <div className="dashboard-data-space-view-providerLinks">
      <BaseSkeleton
        count={count || 3}
        height={20}
        className="find-care-skeleton"
      />
    </div>
  );
}
